const rankEquityList = []

export default {
  rankEquityList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/rank-equity/store/state.js